'use strict';

const { h } = require('phy');
const { Translate } = require('@grpn/preact-l10n');

const getAlphaNumericList = require('../../support/alpha-numeric');

function SidebarBrowseByLetter({ routes }) {
  const links = getAlphaNumericList();
  const letterList = links.map(value =>
    h(
      'li.sidebar-browse-tag',
      h(
        'a.sidebar-browse-tag-link',
        {
          href: `${routes.all_brands.main}#${value}`,
          'data-bhc': `letter:${value}`,
        },
        value
      )
    )
  );

  return h('.sidebar-browse', [
    h(
      Translate,
      { tag: 'h3', attrs: { class: 'sidebar-browse-title' } },
      'modules.shared.BrowseByBrand'
    ),
    h(
      'ul.sidebar-browse-list',
      {
        'data-bhw': 'BrowseByLetter',
      },
      letterList
    ),
  ]);
}

module.exports = SidebarBrowseByLetter;
